var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localScore),expression:"localScore"}],ref:"slider",attrs:{"id":'slider-' + _vm.slug,"type":"text"},domProps:{"value":(_vm.localScore)},on:{"input":function($event){if($event.target.composing)return;_vm.localScore=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }